import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeProviderNormalizationListData, autoEuropeProviderNormalizationIsLoading } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

const PROVIDER_NORMALIZATION_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/provider-normalization`

export default function useAutoEuropeProviderNormalizationTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			autoEuropeProviderNormalizationIsLoading.value = true
			autoEuropeProviderNormalizationListData.value = []
		})
		getSubmit(`${PROVIDER_NORMALIZATION_API}/list`)
			.then(data => {
				batch(() => {
					autoEuropeProviderNormalizationListData.value = data
					autoEuropeProviderNormalizationIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeProviderNormalizationIsLoading.value = false
				showToast.error("Error loading Provider Normalization records")
			})
	}, [])

	return { getTableData }
}